import http from '../const/http-common'

const getPresentations = () => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.get('/v1/user/presentation/get', { headers });
}

const createPresentation = (info) => {
  const {title, model} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post('/v1/user/presentation/create', {title, model}, { headers });
}

const updatePresentation = (info) => {
  const {id, title, model} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post('/v1/user/presentation/update', {id, title, model}, { headers });
}

const deletePresentation = (info) => {
  const {id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.delete(`/v1/user/presentation/${id}/delete`, { headers });
}

const schedulePresentation = (info) => {
  const {presentation, title, recurrence, day, time, destinations} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post(`/v1/user/presentation/schedule`, {id: presentation, mode: 'presentation', title, recurrence, day, time, destinations}, { headers });
}

const generatePresentation = (info) => {
  const {id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.get(`/v1/user/presentation/${id}/generate`, { headers });
}

const createSlide = (info) => {
  const {presentation, title, source, prompt, visualization, comment} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/create_slide', {presentation, title, source, prompt, visualization, comment}, { headers });
}

const updateSlide = (info) => {
  const {presentation, index, title, source, prompt, visualization, comment} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/update_slide', {presentation, index, title, source, prompt, visualization, comment}, { headers });
}
const moveSlide = (info) => {
  const {sourceId, sourceIndex, destinationId, destinationIndex} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/move', {sourceId, sourceIndex, destinationId, destinationIndex}, { headers });
}

const deleteSlide = (info) => {
  const {id, index} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/delete_slide', {id, index}, { headers });
}

const presentationService = {
  getPresentations,
  createPresentation,
  updatePresentation,
  generatePresentation,
  schedulePresentation,
  deletePresentation,
  createSlide,
  updateSlide,
  moveSlide,
  deleteSlide
}

export default presentationService;